import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "2", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "18", y2: "22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4.93", x2: "7.76", y1: "4.93", y2: "7.76", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16.24", x2: "19.07", y1: "16.24", y2: "19.07", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "6", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "22", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4.93", x2: "7.76", y1: "19.07", y2: "16.24", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16.24", x2: "19.07", y1: "7.76", y2: "4.93", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Loader";
const Loader = memo(themed(Icon));
export {
  Loader
};
//# sourceMappingURL=loader.js.map
